import React, { useContext } from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import RankingCard from '../../../shared/components/v3/Cards/RankingCard/RankingCard';
import StepsCard from '../../../shared/components/v3/Cards/StepsCard/StepsCard';
import { PLAN_ROUTE } from '../../../shared/constants/auth';
import { CATEGORY_ICONS } from '../../../shared/constants/benefits';
import { FLEXIBLE_BENEFITS_DETAIL } from '../../../shared/constants/tagManager';
import { CompanyContext } from '../../../shared/context/company/companyContext';
import { PlansContext } from '../../../shared/context/plans/plansContext';
import { useSelectedBenefitsRanking } from '../../../shared/hooks/useSelectedBenefitsRanking/useSelectedBenefitsRanking';
import { TRANSLATIONS_HOME } from '../../../shared/translations/home';
import { TRANSLATION_MY_PLAN } from '../../../shared/translations/plan';
import DetailHeader from '../DetailHeader/DetailHeader';

import './BenefitsToChoose.scss';

const BenefitsToChoose = () => {
  const { company } = useContext(CompanyContext);
  const { bfuChoices } = useContext(PlansContext);

  const {
    ranking,
    loading: loadingRanking,
    error: errorRanking,
    refetch: fetchRanking
  } = useSelectedBenefitsRanking(company.id);

  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="benefits-to-choose-container">
      <DetailHeader
        title={t(TRANSLATION_MY_PLAN.benefitsToChoose.hero.title, { number: bfuChoices, count: bfuChoices })}
        subtitle={t(TRANSLATION_MY_PLAN.benefitsToChoose.hero.description)}
        backAction={() => navigate(PLAN_ROUTE)}
        inverse={true}
      />
      <div className="btc-content">
        <div className="btc-instructions">
          <StepsCard
            title={t(TRANSLATION_MY_PLAN.benefitsToChoose.chooseInstruction.title)}
            steps={[
              <Trans
                i18nKey={TRANSLATION_MY_PLAN.benefitsToChoose.chooseInstruction.step1}
                key="step1"
                components={{ b: <strong /> }}
              />,
              <Trans
                i18nKey={TRANSLATION_MY_PLAN.benefitsToChoose.chooseInstruction.step2}
                key="step2"
                components={{ b: <strong /> }}
              />,
              <Trans
                i18nKey={TRANSLATION_MY_PLAN.benefitsToChoose.chooseInstruction.step3}
                key="step3"
                components={{ b: <strong /> }}
              />,
              <Trans
                i18nKey={TRANSLATION_MY_PLAN.benefitsToChoose.chooseInstruction.step4}
                key="step4"
                components={{ b: <strong /> }}
              />
            ]}
          />
        </div>
        <div className="btc-ranking">
          <RankingCard
            title={t(TRANSLATIONS_HOME.rankingCard.title)}
            valueText={TRANSLATIONS_HOME.rankingCard.collaborators}
            tabBarIcons={CATEGORY_ICONS}
            hasTabBar
            gtmTab={FLEXIBLE_BENEFITS_DETAIL}
            data={ranking}
            loading={loadingRanking}
            error={errorRanking}
            action={fetchRanking}
          />
        </div>
      </div>
    </div>
  );
};

export default BenefitsToChoose;
